import defaultMapJson from '../maps/default.json' with { type: 'json' };
import largeMapJson from '../maps/large.json' with { type: 'json' };
import mediumMapJson from '../maps/medium.json' with { type: 'json' };
import smallMapJson from '../maps/small.json' with { type: 'json' };
import type { MapDef } from './types.ts';

// All maps come from scripts/generate-maps.ts.

/**
 * "Two Coasts", 52×39: the map of games created before game sizes. New games use the size maps
 * (sizes.ts); this one stays so tests and old saved games keep their geography.
 */
export const DEFAULT_MAP: MapDef = defaultMapJson as MapDef;

export const SMALL_MAP: MapDef = smallMapJson as MapDef;
export const MEDIUM_MAP: MapDef = mediumMapJson as MapDef;
export const LARGE_MAP: MapDef = largeMapJson as MapDef;
